// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

/**
 * One OPC UA `node` -> lift binding for a bank, authored by POSITION.
 *
 * Authored at wizard time by POSITION (index), not by lift UUID (real lift UUIDs
 * do not exist yet at the Banks step). `LiftCloud` resolves `lift_index` ->
 * `bank.Lifts[lift_index].ID` when assembling the edge CDO (see
 * `CDO.OpcUaNodeLiftEntry`, which stays UUID-based).
 */
export class OpcUaNodeLiftIndexEntry implements flatbuffers.IUnpackableObject<OpcUaNodeLiftIndexEntryT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): OpcUaNodeLiftIndexEntry {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsOpcUaNodeLiftIndexEntry(
    bb: flatbuffers.ByteBuffer,
    obj?: OpcUaNodeLiftIndexEntry,
  ): OpcUaNodeLiftIndexEntry {
    return (obj || new OpcUaNodeLiftIndexEntry()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsOpcUaNodeLiftIndexEntry(
    bb: flatbuffers.ByteBuffer,
    obj?: OpcUaNodeLiftIndexEntry,
  ): OpcUaNodeLiftIndexEntry {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new OpcUaNodeLiftIndexEntry()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  /**
   * Standard OPC UA `NodeId` STRING encoding (IEC 62541-3 §5.3.1), e.g.
   * "ns=2;s=Elevator1.Car", "ns=2;i=1001", "ns=2;g=<guid>". Same string the
   * frontend's `describeNode()` already produces and `LiftCloud`'s
   * `parseOpcUaNodeIDString` already parses.
   */
  node(): string | null;
  node(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  node(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * 0-based rank of the lift within the bank's Position-sorted lifts (== `CarNum`).
   */
  liftIndex(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : 0;
  }

  static startOpcUaNodeLiftIndexEntry(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addNode(builder: flatbuffers.Builder, nodeOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, nodeOffset, 0);
  }

  static addLiftIndex(builder: flatbuffers.Builder, liftIndex: number) {
    builder.addFieldInt8(1, liftIndex, 0);
  }

  static endOpcUaNodeLiftIndexEntry(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createOpcUaNodeLiftIndexEntry(
    builder: flatbuffers.Builder,
    nodeOffset: flatbuffers.Offset,
    liftIndex: number,
  ): flatbuffers.Offset {
    OpcUaNodeLiftIndexEntry.startOpcUaNodeLiftIndexEntry(builder);
    OpcUaNodeLiftIndexEntry.addNode(builder, nodeOffset);
    OpcUaNodeLiftIndexEntry.addLiftIndex(builder, liftIndex);
    return OpcUaNodeLiftIndexEntry.endOpcUaNodeLiftIndexEntry(builder);
  }

  unpack(): OpcUaNodeLiftIndexEntryT {
    return new OpcUaNodeLiftIndexEntryT(this.node(), this.liftIndex());
  }

  unpackTo(_o: OpcUaNodeLiftIndexEntryT): void {
    _o.node = this.node();
    _o.liftIndex = this.liftIndex();
  }

  unpackFields(...fields: string[]): OpcUaNodeLiftIndexEntryT {
    const t = new OpcUaNodeLiftIndexEntryT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("node")) {
      t.node = this.node();
    }
    if (fieldSet.has("lift_index")) {
      t.liftIndex = this.liftIndex();
    }
    return t;
  }
}

export class OpcUaNodeLiftIndexEntryT implements flatbuffers.IGeneratedObject {
  constructor(
    public node: string | Uint8Array | null = null,
    public liftIndex: number = 0,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const node = this.node !== null ? builder.createString(this.node!) : 0;

    return OpcUaNodeLiftIndexEntry.createOpcUaNodeLiftIndexEntry(builder, node, this.liftIndex);
  }

  clone(): OpcUaNodeLiftIndexEntryT {
    const obj = new OpcUaNodeLiftIndexEntryT();
    obj.node = this.node;
    obj.liftIndex = this.liftIndex;
    return obj;
  }

  equals(other: OpcUaNodeLiftIndexEntryT): boolean {
    if (this.node !== other.node) return false;
    if (this.liftIndex !== other.liftIndex) return false;
    return true;
  }
}

export function verifyOpcUaNodeLiftIndexEntry(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 6, 1);
  } finally {
    verifier.popDepth();
  }
}
